// 宿一覧ページで宿が0件(空)の場合トラッキング
export function trackResortPageEmptyYadoListShown() {
  const eventName = 'RESORT_PAGE_EMPTY_YADO_LIST_SHOWN';
  const url = location.href;
  const resortCodeRegex = /\/snow\/resorts\/([a-z0-9-]+)\/accommodations/;

  const match = url.match(resortCodeRegex);
  if (match.length === 2) {
    const resortCode = match[1];
    console.log(`Tracking ${eventName}`);

    window.gtag('event', eventName, {
      event_label: `Empty Yado List Shown - ${resortCode}`,
    });
  }
}
